/**
 * The app's theme and its setter, from ThemeContext.
 *
 * A hook rather than useContext at each call, so a component outside its
 * provider fails at once with a sentence saying so, instead of reading
 * undefined and failing somewhere further on.
 *
 * @module useTheme
 */

import { useContext } from 'react';
import { ThemeContext, ThemeContextType } from '@/shared/context/ThemeContext';

/**
 * The ThemeProvider's value.
 *
 * @returns The theme now, and setTheme for an unsaved preview.
 * @throws Error when called outside a ThemeProvider.
 */
export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
} 